var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStayInformed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 76.5625L38.4375 49.6875L68.4375 76.5625M7.1875 49.0625L14.6875 40.9375",
    stroke: "url(#paint0_linear_180_6351)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6875 49.0625H7.1875V77.1875H69.6875V49.0625ZM69.6875 49.0625L62.1875 40.9375M41.5625 12.1875H14.6875V45.9375M62.1875 41.5625V47.8125M73.7375 15.8125L71.2937 16.4937",
    stroke: "url(#paint1_linear_180_6351)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5124 14.6063C61.6495 14.4612 62.8008 14.73 63.7561 15.3637C64.7114 15.9973 65.4068 16.9534 65.7154 18.0574C66.024 19.1614 65.9252 20.3395 65.4369 21.3767C64.9487 22.4138 64.1037 23.2407 63.0562 23.7063M42.6624 30.85L29.7062 34.4625C28.7497 34.732 27.7255 34.6108 26.8583 34.1257C25.9911 33.6406 25.352 32.8311 25.0812 31.875L23.4499 26.0313C23.3122 25.554 23.2707 25.0541 23.3278 24.5607C23.385 24.0673 23.5395 23.5901 23.7826 23.1569C24.0256 22.7237 24.3523 22.3431 24.7437 22.0372C25.1351 21.7313 25.5833 21.5062 26.0624 21.375L39.0124 17.7688L41.1624 25.4813",
    stroke: "url(#paint2_linear_180_6351)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9314 18.3811C39.9919 17.6139 42.8194 16.1123 45.1688 14.0061C47.0123 12.3648 48.6493 10.5053 50.0439 8.46864M69.8876 8.97489L68.0001 10.8999M73.7501 23.8561L71.4501 23.2686M22.9439 26.4499L21.6064 26.7686C20.7189 27.0124 20.1376 27.7374 20.3126 28.3811L20.9376 30.7561C21.1126 31.3811 21.9814 31.7186 22.8689 31.4749L24.2064 31.1561M34.5376 44.9811L29.7001 34.9311M56.5439 33.1561C54.4222 32.2365 52.2072 31.5492 49.9376 31.1061C45.7689 30.3186 42.7626 30.7686 41.0376 31.2999C41.0376 31.2999 39.4314 34.5374 39.8376 36.2999C40.2439 38.0624 42.1314 43.2874 42.1314 43.2874C42.5562 44.2149 43.14 45.061 43.8563 45.7874M56.7001 3.68114L65.3251 34.6061C65.7876 36.8311 61.9876 37.8999 61.0501 35.5686L52.4251 4.64989C51.8313 2.44989 55.9564 0.69989 56.7001 3.68114Z",
    stroke: "url(#paint3_linear_180_6351)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_180_6351",
    x1: 7.1878,
    y1: 58.7503,
    x2: 68.4375,
    y2: 58.7503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_180_6351",
    x1: 7.18783,
    y1: 44.688,
    x2: 73.7375,
    y2: 44.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_180_6351",
    x1: 23.3032,
    y1: 24.5856,
    x2: 65.8917,
    y2: 24.5856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_180_6351",
    x1: 20.2818,
    y1: 23.9426,
    x2: 73.7501,
    y2: 23.9426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStayInformed);
export default __webpack_public_path__ + "static/media/Stay Informed.8aba7e78dc2dba8fe49f7112f5c35240.svg";
export { ForwardRef as ReactComponent };